import t from"react";import{mdiPlus as o}from"@mdi/js";import{MdIcon as r}from"./MdIcon.js";const e=({id:e="plus",title:i="plus",...m})=>t.createElement(r,{id:e,title:i,path:o,...m});export{e as PlusIcon};
